import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, InputRef, Space } from 'antd';
import { FilterConfirmProps, FilterDropdownProps } from 'antd/es/table/interface';
import Assets from 'assets/icons';
import React from 'react';
import classes from './UsersTable.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hook';
import {  IPendingInviteUsers, IUsers } from 'interfaces';


type FilterDropdownType = {
  setSelectedKeys: (selectedKeys: React.Key[]) => void;
  selectedKeys: React.Key[];
  confirm: (param?: FilterConfirmProps) => void;
  clearFilters: (() => void) | undefined;
  isFilterDropdownOpen: boolean;
  close: () => void;
  dataIndex: string;
  setAllUsers: React.Dispatch<React.SetStateAction<(IUsers| IPendingInviteUsers)[]>>;
};

const FilterDropdown = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  close,
  isFilterDropdownOpen,
  dataIndex,
  setAllUsers,
}: FilterDropdownType) => {
  const [searchText, setSearchText] = React.useState('');
  const searchInput = React.useRef<InputRef>(null);

  const { dataRoom } = useAppSelector((store) => store.dataRoom);
  const { users, pendingInviteUsers } = useAppSelector((state) => state.dataUsers);  
  
  const { t } = useTranslation();
console.log('FilterDropdown', isFilterDropdownOpen);
  // React.useEffect(() => {
  //   isFilterDropdownOpen && searchInput?.current && searchInput.current.focus();
  // }, [isFilterDropdownOpen]);

  const searchInRoom = async (roomId: string, searchText: string) => {
    if (searchText && searchText?.trim()) {
      setAllUsers((prev: any) => prev.filter((user: any) => user.name && user.name.toLowerCase().includes(searchText?.trim().toLowerCase())))
    } else if (searchText === '' && searchText?.trim() === '') {
      const invites = pendingInviteUsers.map(invite => ({
        ...invite, key: invite.id, type: 'invite'
      }));
      setAllUsers([...users, ...invites].map((user: any) => ({...user, name: user.type === 'user' ? `${user?.first_name!} ${user?.last_name}`: user.email })))  
    }
  };

  React.useEffect(() => {
    searchInRoom(dataRoom?.id!, searchText)
  }, [searchText]); 

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps['confirm'],
    dataIndex: string,
  ) => {
    confirm();
    setSearchText(selectedKeys[0] || '');
    // confirm({closeDropdown: true});  
    // setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText('');
    setSelectedKeys([]);
    confirm();
  };  

  return (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
        ref={searchInput}
        placeholder={t('Users.table.search')}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <Space>
        <Button
          type='primary'
          onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
          icon={<SearchOutlined />}
          size='small'
        >
          {t('Users.table.search_button')}
        </Button>
        <Button
          onClick={() => clearFilters && handleReset(clearFilters)}
          size='small'
        >
          {t('Users.table.search_reset')}
        </Button>
        <Button
          type='text'
          size='small'
          icon={<Assets.CloseIcon className={classes.greyIcon} />}
          onClick={() => close()}
        />
      </Space>
    </div>
  );
};

export default FilterDropdown;
